exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-title[data-v-eeba4980] {\n  color: #4cafb4;\n}\n.label[data-v-eeba4980] {\n  font-size: 15px;\n  color: #878787;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eeba4980","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/components/PaymentLMSG.vue
// module id = 1619
// module chunks = 2